export default __webpack_public_path__ + "static/media/cs_icon_02.36c4012e.png";